import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { AddressBookRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AddressBookState {
    contacts: {
        [key: string]: AddressBookRecord;
    };
}

const initialState: AddressBookState = { contacts: {}};

const addressBookRecordAction = createAction<AddressBookRecord>(CoreMsgTypes.AddressBookRecord);
const setContactsAction = createAction<{ addresses: AddressBookRecord[] }>('SET_CONTACTS');

const addressBookSlice = createSlice({
    name: 'addressBook',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                addressBookRecordAction,
                (state, action) => {
                    state.contacts[action.payload.AddressBookId] = action.payload;
                }
            )
            .addCase(
                setContactsAction,
                (state, action) => {
                    if (!action.payload.addresses) {
                        return state;
                    } else {
                        const contacts = {};
                        action.payload.addresses?.forEach((contact: AddressBookRecord) => {
                            contacts[contact.AddressBookId] = contact;
                        });

                        state.contacts = contacts;
                    }
                }
            )
            .addDefaultCase(state => state);
    }
});

export default addressBookSlice.reducer;